import { Typography } from "@mui/material";
import { LabelOutlined } from "@mui/icons-material";

import { IndicatorBase } from "types";

interface Props {
  indicator: IndicatorBase;
}

export function LayerCardDetails(props: Props) {
  return render();

  function render() {
    if (!props.indicator) return null;

    return (
      <>
        {props.indicator.information.map((info, i) => (
          <Typography
            key={[info.label, i].join("-")}
            variant="body2"
            className="layer-information"
            color="text.secondary"
            gutterBottom
          >
            <strong>{info.label}</strong>: {info.value}
          </Typography>
        ))}

        <Typography component="p" className="text-start-adornment tag-list">
          <LabelOutlined />
          {props.indicator.tags.join(", ")}
        </Typography>
      </>
    );
  }
}
